import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZileLibereComponent } from './zile-libere.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddZileLibereComponent } from './add-zile-libere/add-zile-libere.component';
import { EditZileLibereComponent } from './edit-zile-libere/edit-zile-libere.component';



@NgModule({
    declarations: [
        ZileLibereComponent,
        AddZileLibereComponent,
        EditZileLibereComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ZileLibereComponent]
})
export class ZileLibereModule { }
